import PropTypes from 'prop-types';
import React from 'react';
import DropdownLayout from '../../../Layout/DropdownLayout/DropdownLayout';
import Menu from '../../Menu/Menu';

import './UserDropdown.scss';

export default class UserDropdown extends React.PureComponent {
    static propTypes = {
        /**
         * Whether the dropdown is open
         */
        isDropdownOpen: PropTypes.bool.isRequired,
        /**
         * handler for closing
         */
        onClose: PropTypes.func.isRequired,
        /**
         * text to be display on topbar
         */
        headerText: PropTypes.string.isRequired,
        /**
         * image src to be displayed on top bar
         */
        profileImage: PropTypes.string.isRequired,
        /**
         * list of items to be displayed in user menu
         */
        menuItems: PropTypes.array.isRequired,
        /**
         * style to override default
         */
        className: PropTypes.string,
    };

    static defaultProps = {
        isDropdownOpen: false,
        onClose: () => {},
        menuItems: [],
        headerText: '',
        profileImage: '/v1/avatar_black_160_vtg7lw.svg',
        className: '',
    };

    render() {
        const {
            isDropdownOpen,
            profileImage,
            headerText,
            onClose,
            menuItems,
            className,
        } = this.props;

        if (!isDropdownOpen) {
            return null;
        }

        return (
            <DropdownLayout
                cssClass={`component-Layout-Header-Modules-Dropdowns-UserDropdown ${className}`}
                shouldShowDropdown={true}
                profileImage={profileImage}
                headerText={headerText}
                onClose={onClose}
            >
                <Menu menuItems={menuItems} />
            </DropdownLayout>
        );
    }
}
